export function formatNumber(value: unknown, fractionDigits = 2): string {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return "—";
  }
  return value.toFixed(fractionDigits);
}

export function formatDelta(value: unknown, fractionDigits = 1): string {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return "—";
  }
  const rounded = value.toFixed(fractionDigits);
  return value > 0 ? `+${rounded}` : rounded;
}

export function deltaTone(value: unknown): "up" | "down" | "flat" {
  if (typeof value !== "number" || Math.abs(value) < 0.05) {
    return "flat";
  }
  return value > 0 ? "up" : "down";
}

export function clampPercent(value: unknown): number {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return 0;
  }
  return Math.max(0, Math.min(100, value));
}

export function asString(value: unknown, fallback = ""): string {
  return typeof value === "string" ? value : fallback;
}
